/**
 * Parse cover/issue dates from API (epoch ms/sec, ISO date-only, or datetime).
 * @param {string|number|null|undefined} value
 * @returns {Date|null}
 */
export function parseCoverDate (value) {
  if (value == null || value === '') return null

  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value < 1e11 ? value * 1000 : value
    const d = new Date(ms)
    return Number.isNaN(d.getTime()) ? null : d
  }

  const str = String(value).trim()
  if (!str) return null

  if (/^\d+$/.test(str)) {
    const n = Number(str)
    if (!Number.isFinite(n)) return null
    const ms = n < 1e11 ? n * 1000 : n
    const d = new Date(ms)
    return Number.isNaN(d.getTime()) ? null : d
  }

  const dateOnly = str.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (dateOnly) {
    const y = Number(dateOnly[1])
    const m = Number(dateOnly[2]) - 1
    const day = Number(dateOnly[3])
    const d = new Date(y, m, day)
    return Number.isNaN(d.getTime()) ? null : d
  }

  const d = new Date(str)
  return Number.isNaN(d.getTime()) ? null : d
}

/**
 * Display cover date (en-US long format) without timezone off-by-one on date-only values.
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
export function formatCoverDate (value) {
  const d = parseCoverDate(value)
  if (!d) return ''
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}
